import { Revealer, ReavealerState } from "./Revealer";
import { RevealerFull } from "./RevealerFull";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { SanSymbolData } from "../../../engine/Symbol/SanSymbolData";

export class RevealerManager {
    
    private amount:number = 5;

    protected static revealer_Top:Revealer[];
    protected static revealer_Bot:Revealer[];

    protected static fullReelRevealer:RevealerFull[];


    protected text:PIXI.Text;

    public static getTopBar(pos:number):Revealer{
        return this.revealer_Top[pos];
    }

    public static getBotBar(pos:number):Revealer{
        return this.revealer_Bot[pos];
    }

    public static getAllBars():Revealer[]{
        return this.revealer_Bot.concat(this.revealer_Top);
    }

    public static FullRevealer(pos:number):RevealerFull{
        return this.fullReelRevealer[pos];
    }

    constructor (){
        RevealerManager.revealer_Top = this.createRevealers(true);
        RevealerManager.revealer_Bot = this.createRevealers(false);
         
        RevealerManager.fullReelRevealer = ArrayHelper.initArrayWithValues(this.amount, () => { return new RevealerFull() });

        this.addEventListener();
    }

    public static shuffleAll():void{
        RevealerManager.getAllBars().forEach((rev:Revealer) => rev.shuffle(true));
    }

    public static resetIdle():void{
        RevealerManager.getAllBars().forEach((rev:Revealer) => rev.resetIdleTimeline());
    }

    public static setResData(top?:string[], bot?:string[], mystSym?:string,isFS?:boolean):void{

        if(top) RevealerManager.revealer_Top.forEach((rev:Revealer, indx:number) => rev.setResult(top[indx],mystSym!,isFS));
        if(bot) RevealerManager.revealer_Bot.forEach((rev:Revealer, indx:number) => rev.setResult(bot[indx],mystSym!,isFS));

        for(let k:number = 0; k < RevealerManager.revealer_Top.length; k++){
            if(RevealerManager.revealer_Top[k].state.equal(ReavealerState.EXPANDING) && (RevealerManager.revealer_Bot[k].state.equal(ReavealerState.EXPANDING))){
                if(top) RevealerManager.revealer_Top[k].setResult(top[k],"W"!,isFS);
                if(bot) RevealerManager.revealer_Bot[k].setResult(bot[k],"W"!,isFS);
            }
        }
    }

    public static setFSSymbol(sym:string,val:number):void{
        RevealerManager.getAllBars().forEach(b => b.setFSSymbol(sym,val))
    }
    
    public static getRevealer(reel:number, pos:number):Revealer{
        return (pos > 0 ?  RevealerManager.revealer_Top : RevealerManager.revealer_Bot)[reel];
    }

    protected addEventListener():void{
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_RESIZED, () => this.onResize());
    }

    private createRevealers(top:boolean):Revealer[] {
        const temp:Revealer[] = [];
        for(let i:number = 0; i < this.amount;i++) temp.push(new Revealer(i,top));
        return temp;
    }

    private onResize():void{
        for(let r:number = 0; r < RevealerManager.revealer_Top.length; r++){
            RevealerManager.revealer_Top[r].onResize();
            RevealerManager.revealer_Bot[r].onResize();
        }

        RevealerManager.fullReelRevealer.forEach((rev:RevealerFull, indx:number) => {
            const reelScaledY:number = SanEngineManager.dim.scale.y;
            const scaledHeight:number = SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * reelScaledY;
            // const toPosition: Point = SanEngineManager.getReel(indx).getCurrentStatePositionMap(rev)[1];
            rev.position = MathHelper.pointAdd(SanEngineManager.getReelPos(indx), new PIXI.Point(0,scaledHeight));
            rev.scale = SanEngineManager.dim.scale;
        });

    }
}